/**
 *
 * TrailModeBook
 *
 */

import { findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Swal from 'sweetalert2';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
import { ClassChineseFrmMixin } from '@/mixins/ClassChineseFrm';
import { getDurationString } from '../../../utils';

export default {
  name: 'TrailModeBook',

  mixins: [ClassChineseFrmMixin],

  components: {
    WayFindBar,
    Footer,
    Spinner,
    Player,
  },

  data: () => {
    return {
      isShowPlayer: false,
      currentVideo: {},
      generating: false,
    };
  },

  computed: {
    ...mapGetters({
      Book: 'TrailModeBook/Book',
      immLoading: 'immLoading',
      isRequest: 'TrailModeBook/isRequest',
      ReadyToPlayVideos: 'TrailModeBook/ReadyToPlayVideos',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    BookId: function () {
      return this.$route.params.bookId;
    },
  },

  created() {
    this.getBook(this.BookId);
  },

  methods: {
    ...mapActions({
      getBook: 'TrailModeBook/getBook',
      addToFavoriteList: 'TrailModeBook/addToFavoriteList',

      generateFile: 'TrailModeBook/generateFile',
    }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find(v => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    goToNextVideo() {
      const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    goBack() {
      this.$router.go(-1);
    },

    async generatePDF(file) {
      this.generating = true;
      await this.generateFile({
        courseId: this.CourseId,
        bookId: this.BookId,
        fileId: file.fileId,
      });
      this.generating = false;
    },

    async markVideo(payload) {
      await this.addToFavoriteList(payload);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.currentVideo.collected ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    changeBulletStatus(video, status) {
      this.$store.commit('TrailModeBook/SET_BULLET_STATUS', { video, status });
    },

    getDurationStringText(second) {
      return getDurationString(second);
    },
  },
};
